import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { I18nProvider } from './i18n';

import store from './store';
import App from './app';
import history from './history';
import { ensureJSInjected } from './utils/mobile';

import './patch';
import './styles/import';

const renderApp = () => {
  ReactDOM.render((
    <Provider store={store}>
      <I18nProvider>
        <Router history={history}>
          <App />
        </Router>
      </I18nProvider>
    </Provider>
  ), document.getElementById('root'));
};

ensureJSInjected.then(renderApp);



// WEBPACK FOOTER //
// ./src/index.js